

import {
  DatePick,
  RefBox,
  InputItem,
  RefPage,
  RefTree,
  InventoryList,
  Test,
  Element
} from '../../index';

import React from 'react';
import { TopNavPage } from 'mutants-mobile-navigator';

@TopNavPage
export default class Test1 extends React.Component {



  state = {
    data: [
      { component: 'refBox', value: '客户1', name: '我是参照', code: 'one', required: true, dtoName: 'InventoryDTO' },
      { component: 'inputItem', value: '客户1', name: '我是输入框', code: 'two' },
      { component: 'datePick', value: '', name: '我是日期', code: 'three' },
      { component: 'refBox', value: '', name: '我是可编辑参照', code: 'four', writable: true, dtoName: 'PartnerDTO' },
      { component: 'checkButton', value: true, name: '我是checkbox', code: 'five' },
      { component: 'buttonGroup', value: { id: 1, name: '111' }, items: [{ id: 1, name: '111' }, { id: 2, name: '222' }], name: '我是groupButton', code: 'six' },
      {
        component: 'refBox', value: '', name: '我是groupButton', code: 'seven', options: {
          "Name": "Warehouse",
          "Title": "仓库",
          "FieldName": "Warehouse",
          "ControlType": "RefComplexBox",
          "FieldType": "DTO",
          "ReadOnly": false,
          "AllowNone": true,
          "MaxLength": 0,
          "Precision": 3,
          "EnumName": "",
          "RefDTOName": "WarehouseDTO",
          "RefShowField": "",
          "RefDataSource": "RefWarehouseDTO",
          "RefWhere": null,
          "DefaultValue": "",
          "RowWidth": 0,
          "IsNegativeFormat": false,
          "TabID": 32,
          "GroupID": 134,
          "IsTitle": false,
          "IsRecord": false,
          "Format": "",
          "RelationFields": "",
          "IsDetail": false,
          "ProcessBlocks": ["WarehousesBlock"],
          "DefaultEventOfAction": "dispatchProcessProcessBlockByFlieName"
        },
        template: {
          "Name": "RefPartnerDTO",
          "ColSetField": ["Field", "ShowCaption", "FieldType", "IsNegativeFormat", "IsTitle", "RowWidth", "Precision", "GroupID"],
          "ColSetValue": [
           ["Name", "往来单位名称", "string", true, true, 100,0, 0],
           ["Code", "往来单位编码", "string", true, false, 50, 0, 0],
           ["SettlementPartner.Name", "结算客户", "string", true, false,50, 0, 0]
          ]
         }
      },
    ]
  }

  onChange = (code, value) => {
    let _data = this.state.data;
    _data.find(item => item.code == code).value = value;
    this.setState({
      data: _data
    })
  }






  render() {
    let fn = value => { console.log(value) }
    return (
      <div>
        {/* <DatePick onChange={fn} value={"2019-07-20"} />
        <InputItem type='' percent onChange={fn} value='1123' />
        <RefBox value={'客户一'} onChange={fn} dtoName="InventoryDTO" writable /> */}

        {/* <Element component='refBox' value='客户1' name='我是参照' />
        <Element component='refBoxInput' value='客户2' name='我是可编辑参照' />
        <Element component='datePick' value='' name='单据日期'  />
        <Element component='buttonGroup' 
          value={{id: 1, name: '选项1'}} 
          items={[{id: 1, name: '选项1'}, {id: 2, name: '选项2'}, {id: 3, name: '选项3'}]}
          name='票据类型'
          />
        <Element component='checkButton' value={false} name='自动生成出库单' />
        <Element component='inputItem' value='啊啊啊' name='普通输入框' />
        <Element component='inputItem' value='啊啊啊' type='数字输入框' name='客户手机号' /> */}
        {/* <RefPage params={params} /> */}
        {/* <RefTree /> */}
        {/* <InventoryList /> */}

        {
          this.state.data.map(({ component, name, value, ...options }) => (
            <Element component={component} name={name} value={value} {...options} onChange={this.onChange} />
          ))
        }
      </div>
    )
  }
}

